import React, { useState } from 'react';
import axios from 'axios';

interface LoginProps {
  onLogin: (token: string) => void;
}

export default function Login({ onLogin }: LoginProps) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errore, setErrore] = useState('');
  const [caricando, setCaricando] = useState(false);

  const handleLogin = async () => {
    if (!username || !password) {
      setErrore('Inserisci username e password');
      return;
    }
    setCaricando(true);
    setErrore('');
    try {
      const res = await axios.post(process.env.REACT_APP_API_URL + '/api/auth/login', {
        email: username,
        password
      });
      onLogin(res.data.access_token);
    } catch (e: any) {
      setErrore(e.response?.data?.detail || 'Credenziali errate');
    } finally {
      setCaricando(false);
    }
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <h1 style={{ color: '#2c3e50', marginBottom: '0.3rem' }}>🏛️ Reconcilia ADR</h1>
        <p style={{ color: '#777', marginBottom: '2rem' }}>Sistema Firma Digitale — Accesso Admin</p>

        {errore && (
          <div style={{ padding: '0.8rem', background: '#fdecea', border: '1px solid #e74c3c', borderRadius: '6px', marginBottom: '1rem', color: '#c0392b' }}>
            ❌ {errore}
          </div>
        )}

        <div style={{ marginBottom: '1rem' }}>
          <label style={labelStyle}>Username</label>
          <input
            value={username}
            onChange={e => setUsername(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleLogin()}
            placeholder="admin"
            style={inputStyle}
            autoFocus
          />
        </div>

        <div style={{ marginBottom: '1.5rem' }}>
          <label style={labelStyle}>Password</label>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleLogin()}
            placeholder="••••••••"
            style={inputStyle}
          />
        </div>

        <button
          onClick={handleLogin}
          disabled={caricando}
          style={{ ...btnStyle, opacity: caricando ? 0.7 : 1 }}
        >
          {caricando ? 'Accesso in corso...' : '🔐 Accedi'}
        </button>
      </div>
    </div>
  );
}

const containerStyle: React.CSSProperties = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#f0f2f5',
  fontFamily: 'Arial, sans-serif'
};

const cardStyle: React.CSSProperties = {
  background: 'white',
  padding: '2.5rem',
  borderRadius: '12px',
  boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
  width: '100%',
  maxWidth: '400px',
  textAlign: 'center'
};

const labelStyle: React.CSSProperties = {
  display: 'block',
  textAlign: 'left',
  marginBottom: '0.4rem',
  fontWeight: 'bold',
  color: '#2c3e50',
  fontSize: '0.9rem'
};

const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '0.7rem',
  borderRadius: '6px',
  border: '1px solid #ccc',
  fontSize: '1rem',
  boxSizing: 'border-box'
};

const btnStyle: React.CSSProperties = {
  width: '100%',
  padding: '0.9rem',
  background: '#2c3e50',
  color: 'white',
  border: 'none',
  borderRadius: '6px',
  fontSize: '1rem',
  cursor: 'pointer',
  fontWeight: 'bold'
};